import { ArrowRightIcon, InfoCircledIcon } from '@radix-ui/react-icons';
import { useState, useEffect } from 'react';

const VersionNotification = () => {
  // Initialize from localStorage: show notification if the flag is set.
  const [showNotification, setShowNotification] = useState(
    localStorage.getItem("versionMismatch") === "true"
  );
  // Retrieve the new version from localStorage.
  const [newVersion, setNewVersion] = useState(localStorage.getItem("newVersion"));

  useEffect(() => {
    // Whenever a mismatch is triggered, read the updated info from localStorage
    const handleVersionMismatch = () => {
      setShowNotification(true);
      setNewVersion(localStorage.getItem("newVersion") || "");
    };

    window.addEventListener('versionMismatch', handleVersionMismatch);
    return () => window.removeEventListener('versionMismatch', handleVersionMismatch);
  }, []);

  if (!showNotification) return null;

  return (
    <div className='fixed bottom-0 z-50 mb-4 w-full pt-1 flex justify-center'>
      <div className='w-11/12 md:w-5/6 p-3 flex flex-col bg-yellow-200 rounded-md items-center h-fit'>
        <div className='flex items-center'>
          <InfoCircledIcon className="mr-3 size-6 md:size-4" />
          <span>En ny version är tillgänglig. <a
            className="cursor-pointer font-medium underline hover:no-underline"
            onClick={() => {
              // localStorage.removeItem("versionMismatch");
              // localStorage.removeItem("newVersion");
              window.location.reload();
            }}
          >Ladda om sidan</a> för att få den senaste versionen.</span>
        </div>
        <span className='flex items-center gap-1 text-xs text-muted-foreground'>{process.env.REACT_APP_VERSION} <ArrowRightIcon /> {newVersion} </span>
      </div>
    </div>
  );
};

export default VersionNotification;
